// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { push } from 'react-router-redux'
import { initialize } from 'redux-form'
import { cleanAllComments } from 'redux/modules/databaseDetails'
import { fetchAntennaSpecById } from 'helpers/api'
import getAntennaPatterns from './getAntennaPatterns'
import setNewAntennaInitialValues from './setNewAntennaInitialValues'
import formatAntennaDataForDetails from './formatAntennaDataForDetails'

const setAntennaDetails = antennaIdStr => async (dispatch, getState) => {
  const { user } = getState()
  const unitType = user.getIn(['defaultUnitType', 'unitType'])
  const patterns = await dispatch(getAntennaPatterns())

  let initialAntennaValues

  const antennaDetails = {
    comments: [],
    dbSet: 'antenna',
    error: '',
    initialValues: {},
    isNewEntity: true,
  }

  try {
    // if it's called 'new-antenna', there's no reason to hit the API.
    // but we want to treat it the same as an API error
    // because we'll show new form values for both scenarios.
    if (antennaIdStr === 'new-antenna') {
      const err = {}
      throw err
    }

    // try to get the existing antenna from the API. (based on the url as antennea spec id)
    const { entity } = await fetchAntennaSpecById(antennaIdStr)
    const entityId = entity.antennaSpecId
    initialAntennaValues = formatAntennaDataForDetails(entity, patterns, unitType)
    antennaDetails.comments = cleanAllComments(entity.comments, 'antennaSpecCommentId')
    antennaDetails.isNewEntity = false
    antennaDetails.entityId = entityId
    antennaDetails.sourceForm = `antenna-details-${entityId}`
  } catch (err) {
    // if err.message then a proper error was thrown
    // if we're on 'new-antenna', there will be no message so don't log it. we meant to be here
    if (err.message) {
      console.warn(err)
    }

    // non-database users cannot create new antennas.
    // after here, all we're doing is getting ready to set up a brand new entity
    // so if the user does not have db access, GET EM OUTTA HERE!
    if (!user.getIn(['permissions', 'database'])) {
      return dispatch(push('/database-management/antenna'))
    }

    const {
      error,
      initialValues,
    } = await setNewAntennaInitialValues(patterns, unitType)

    // allows for an error from either fetch request to persist through for UI.
    antennaDetails.error = err.message || error
    initialAntennaValues = initialValues
    antennaDetails.sourceForm = `antenna-details-${antennaIdStr}`
  }

  await dispatch(initialize(antennaDetails.sourceForm, initialAntennaValues))

  return antennaDetails
}

export default setAntennaDetails
